import template from './wysiwyg.html';
import controller from './wysiwyg.controller';
import './wysiwyg.scss';

let wysiwygComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    value: '=',
    validationError: '<'
  },
  template,
  controller
};

export default wysiwygComponent;
